// client/src/utils/pointsCalculation.js

/**
 * Points awarded for match results in the standings system
 */
export const MATCH_POINTS = {
  WIN_2_0: 8, // Dominant win (2-0)
  WIN_2_1: 6, // Competitive win (2-1)
  LOSS_1_2: 3, // Competitive loss (1-2)
  LOSS_0_2: 2, // Sweep loss (0-2)
}

/**
 * Minimum matches required to be eligible for standings
 */
export const MINIMUM_MATCHES_FOR_ELIGIBILITY = 3

/**
 * Calculate points for a match result
 * @param {number} winnerSetCount - Number of sets won by the winner
 * @param {number} loserSetCount - Number of sets won by the loser
 * @param {boolean} isWinner - Whether calculating points for the winner
 * @param {string} matchFormat - Match format ('TRADITIONAL' or 'PRO_SET_8')
 * @returns {number} Points earned for this match
 */
export function calculateMatchPoints(
  winnerSetCount,
  loserSetCount,
  isWinner,
  matchFormat = 'TRADITIONAL',
) {
  if (matchFormat === 'PRO_SET_8') {
    // PRO_SET_8: 1 point for a win, 0 for a loss
    return isWinner ? 1 : 0
  }
  if (isWinner) {
    // Winner gets 8 for 2-0, 6 for 2-1
    return winnerSetCount === 2 && loserSetCount === 0
      ? MATCH_POINTS.WIN_2_0
      : MATCH_POINTS.WIN_2_1
  } else {
    // Loser gets 3 for 1-2, 2 for 0-2
    return loserSetCount === 1 ? MATCH_POINTS.LOSS_1_2 : MATCH_POINTS.LOSS_0_2
  }
}
